import React, {Component} from 'react';
import {Label, Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {b64toBlob, getLabelByValue, RightExists, showAxiosError} from "../../util/Helpers";
import {API_BASE_URL} from "../../constants";
import './Payment.css';
import ReceiptForm from "./ReceiptForm";
import FileSaver from "file-saver";
import moment from "moment";


class ReceiptList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedReceipt: null,
            receipts: [],
            transactionChannels: [],
            transactionTypes: [],
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            addReceiptModal: false,
            mode: "create"
        };

        this.listReceipts = this.listReceipts.bind(this);
        this.cancelReceiptCreation = this.cancelReceiptCreation.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.listIncomeTypes = this.listIncomeTypes.bind(this);
        this.listTransactionChannels = this.listTransactionChannels.bind(this);
    }

    componentDidMount() {
        this.listIncomeTypes();
        this.listTransactionChannels();
    }


    listIncomeTypes() {
        let self = this;
        let params = {
            //url: API_BASE_URL+"/transaction-type/expenses" ,
            url: API_BASE_URL + "/transaction-type/list",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let transactionTypes = response.data;
                self.setState({
                    transactionTypes,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listTransactionChannels() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/transaction-channel/list",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let transactionChannels = response.data;
                self.setState({
                    transactionChannels,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }


    listReceipts(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=id,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: API_BASE_URL + '/receipt/fetchReceipts?page=' + page + '&size=' + size + sortStr + searchQuery,
            method: "get",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                console.log("response.data", response.data);
                let receipts = response.data.content;
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    receipts,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    addNew() {
        let self = this;
        self.setState({
            selectedReceipt: null,
            addReceiptModal: true
        })
    }


    cancelReceiptCreation() {
        this.setState({
            addReceiptModal: false,
            selectedReceipt: null,
        })
    }

    handleEdit(item) {
        let self = this;
        let data = item.id;
        let params = {
            url: API_BASE_URL + "/receipt/" + item.id,
            data: data,
            method: 'get'
        };
        request(params).then(function (response) {
            self.setState({
                mode: 'edit',
                selectedReceipt: response.data,
                addReceiptModal: true
            })
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.listReceipts(this.state.accessor, this.state.direction, this.state.page, this.state.size))
    }

    handleExport(item) {
        let params = {
            url: API_BASE_URL + "/receipt/create-form/" + item.id,
            method: 'get'
        };
        request(params).then(function (response) {
            const data = response.data.substring(response.data.indexOf(',') + 1);
            var blob = b64toBlob(data, 'application/pdf;charset=utf-8');
            FileSaver.saveAs(blob, item.receiptNo + "_" + item.branchId + "_Makbuz.pdf");
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    render() {
        const {receipts} = this.state;
        let branchSelectdata;
        let citySelectdata;
        const {branches} = this.props;
        const {cities} = this.props;
        const header_ = [{value: null, label: "Tümü"}];

        const header = [{value: null, label: "Tümü"}, {value: "0", label: "BİRLİK MERKEZİ"},];
        branches ? branchSelectdata = header.concat(branches) : branchSelectdata = header;
        cities ? citySelectdata = header_.concat(cities) : citySelectdata = header_;

        const columns = [

            {
                Header: "Makbuz No",
                accessor: "receiptNo",
            },
            {
                Header: "Kimden Alındığı",
                accessor: "receivedFrom",
            },
            {
                Header: "Tahsil Eden",
                accessor: "receivedBy",
            },
            {
                Header: "Tutar",
                accessor: "totalAmount",
                Cell: item => (
                    <label>{item.totalAmount && item.totalAmount + " ₺"}</label>)
            },
            {
                Header: "Makbuz Tarihi",
                accessor: "receiptDate",
                Cell: item => (
                    <label>{item.receiptDate && moment.utc(item.receiptDate).format("DD.MM.YYYY")}</label>)
            },
            /*{
                Header: "Oda",
                accessor: "",
                Cell: item => (
                    <label>{item.branchId && branchSelectdata[item.branchId].label.toString().substring(0,20)+"..." }</label>
                )
            },*/

        ];

        if (this.props.currentUser.realm.toString() === "0") {
            columns.push({
                Header: "Oda",
                accessor: "branchId",
                Cell: item => (
                    <label>{branchSelectdata && getLabelByValue(branchSelectdata, item.branchId).toString().substring(0, 15) + ".."}</label>
                )
            });
        }


        columns.push({
            Header: "İşlemler",
            accessor: "",
            sortable: false,
            Cell: item => (
                <div>
                    <button type="button"
                            onClick={() => this.handleEdit(item)}
                            data-toggle="tooltip" data-placement="bottom" title="Düzenle"
                            style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
                            rel="tooltip" className="Btn btn-sm btn-icon">
                        <i className="fa fa-edit"/>
                    </button>
                    <button type="button"
                            onClick={() => this.handleExport(item)}
                            data-toggle="tooltip" data-placement="bottom" title="Dosya İndir"
                            style={{background: 'linear-gradient( rgb(241, 241, 37), rgb(220, 214, 8))'}}
                            rel="tooltip" className="Btn btn-sm btn-icon">
                        <i className="fas fa-download"/>
                    </button>
                </div>
            )
        })

        const fields = [
            {
                accessor: "receiptNo",
                label: "Makbuz No",
                type: "text",
                operator: "=",
            },
            {
                accessor: "receivedFrom",
                label: "Kimden Alındığı",
                type: "text",
                operator: "=",
            },
            {
                accessor: "totalAmount",
                label: "Tutar",
                type: "text",
                operator: "=",
            },
            {
                label: "Makbuz Tarihi(..'den Sonra)",
                accessor: "min_receiptDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: ">=",
            },
            {
                label: "Makbuz Tarihi(..'den Önce)",
                accessor: "max_receiptDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: "<=",
            },
        ];

        if (this.props.currentUser.realm.toString() === "0") {
            fields.push({
                label: "Oda",
                accessor: "branchId",
                type: "select",
                operator: "=",
                selectData: branchSelectdata,
            },);
        }

        fields.push({
            label: "İl",
            accessor: "member.city.id",
            type: "select",
            operator: "=",
            selectData: citySelectdata,
        },);

        return (
            <div className="financial-transaction-list-container">
                <div className="row baseBackground">
                    <div className="col-md-12 satirBasi">
                        <div className="card-header ">
                            <h4 className="card-title">Fatura Listesi</h4>
                        </div>
                        <div className="card-body mt-1">
                            <div className=" ">
                                <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                    <DetailedSearch fields={fields}
                                                    loading={this.state.searching}
                                                    onSearch={this.handleSearch}/>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <Table
                                loading={this.state.loading}
                                loadingText="Kayıtlar getiriliyor..."
                                content={receipts}
                                total={this.state.total}
                                page={this.state.page}
                                manual={this.state.manual}
                                size={this.state.size}
                                options={["5", "10", "20", "50", "100"]}
                                columns={columns}
                                fetchData={this.listReceipts}
                                style={{width:"100%"}}
                            />
                        </div>
                    </div>
                    <div className="col-sm-12 row">
                        <div className="col-sm-10">
                            <Label style={{color: "red", fontWeight: "bold"}}> MAKBUZLAR YENİ GELİR OLUŞTURDUĞUNUZDA
                                OTOMATİK ÜRETİLECEKTİR! </Label>
                        </div>

                        {
                            (RightExists("ROLE_RIGHT_PAYMENT_CREATE", this.props.authorities))
                            &&
                            <div className="col-sm-2">
                                <div className="new-button-holder">
                                    <button type="button" data-toggle="tooltip" data-placement="bottom"
                                            title="Yeni Makbuz Ekle"
                                            disabled
                                            style={{
                                                background: 'linear-gradient(#2b93cd, #0a66b7)',
                                                height: '40px',
                                                width: '160px',
                                                float: 'right',
                                                marginRight: '30px',
                                                color: 'white',
                                                borderRadius: '0.375em',
                                            }}
                                            className="TekBtn add-new-member "
                                            rel="tooltip"
                                            onClick={() => this.addNew()}>
                                        YENİ MAKBUZ EKLE
                                    </button>
                                </div>
                            </div>
                        }
                    </div>

                    <Modal isOpen={this.state.addReceiptModal} size="lg" className="ust">
                        <ModalHeader toggle={this.cancelReceiptCreation}>Makbuz Oluşturma</ModalHeader>
                        <ModalBody>
                            <ReceiptForm cancelProcess={this.cancelReceiptCreation}
                                         selectedReceipt={this.state.selectedReceipt}
                                         mode={this.state.mode}
                                         currentUser={this.props.currentUser}
                                         handleSearch={this.handleSearch}
                                         transactionTypes={this.state.transactionTypes}
                                         transactionChannels={this.state.transactionChannels}
                            />
                        </ModalBody>
                    </Modal>
                </div>
            </div>
        )
    }
}

export default ReceiptList;



// WEBPACK FOOTER //
// ./src/page/financial/ReceiptList.js